module.exports = __webpack_public_path__ + "img/banner2.48ba14b2.png";